import { render } from "./AppMenu.vue?vue&type=template&id=b89e4d9a"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=b89e4d9a&lang=scss"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\italiafinanza-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__